import type { IconSvgObject } from './types';

const ArtificialIntelligence02Icon: IconSvgObject = [
  ["path", { d: "M15 22V18.5L17.876 18.8595C18.4728 18.9341 19 18.4687 19 17.8672V14.5L21 13L19 10C19 5.58172 15.4183 2 11 2C6.58172 2 3 5.58172 3 10C3 13.5452 5.30607 16.5518 8.5 17.6016M6 16.2454V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 7V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 12L8.3 10M12 12L11.2 10M8.3 10L9.5 7H10L11.2 10M8.3 10H11.2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArtificialIntelligence02Icon;
